import React, { useEffect } from "react";

import {
  createTheme,
  StyledEngineProvider,
  ThemeProvider
} from "@mui/material/styles";
import { CssBaseline, GlobalStyles } from "@mui/material";
// import { useLocation } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

// import { orinetationhandler } from "./utils/helper";
import getTheme from "./theme";
// import { getSportsStart } from "./sports-redux-saga/redux/sport/sports";
import ToasterWrapper from "./container/ToasterWrapper";
import useOverflowObserver from "./Hooks/useOverflowObserver";
import Maintenance from "./container/MaintenanceWrapper/Maintenance";
import { currentOrientation } from "./redux-saga/redux/settings";
import ErrorBoundary from "./components/ErrorBoundary";
import i18n from "./i18n";
import AppWrapper from "./AppWrapper";

import "./assets/Flags.css";
import "./App.css";

function App() {
  const seletedTheme = useSelector((state) => state.settings.theme);
  const selectTheme = getTheme(seletedTheme);
  useOverflowObserver();
  const theme = createTheme(selectTheme);
  const dispatch = useDispatch();

  useEffect(() => {
    // orinetationhandler(dispatch);

    dispatch(
      currentOrientation(
        window?.screen?.orientation?.type !== "portrait-primary"
          ? "LANDSCAPE"
          : "PORTRAIT"
      )
    );
  }, [dispatch]);

  return (
    <ErrorBoundary>
      <>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <I18nextProvider i18n={i18n}>
              <CssBaseline />
              <GlobalStyles
                styles={{
                  "*::-webkit-scrollbar": {
                    width: "6px",
                    height: "0px"
                  },
                  "*::-webkit-scrollbar-track": {
                    background: selectTheme.palette?.scroll?.[350]
                  },
                  "*::-webkit-scrollbar-thumb": {
                    background: selectTheme.palette?.scroll?.track,
                    borderRadius: "10px"
                  }
                }}
              />
              <Maintenance>
                <AppWrapper />
              </Maintenance>
              <ToasterWrapper />
            </I18nextProvider>
          </ThemeProvider>
        </StyledEngineProvider>
      </>
    </ErrorBoundary>
  );
}

export default App;
